import { useTranslation } from "react-i18next";

import cajueiroPirangi from "../../../assets/cajueiroPirangi.png";
import cajueiroRei from "../../../assets/cajueiroRei.png";
import Scroll from "../../Scroll/Scroll";

export default function Cajueiros() {
  const { t } = useTranslation();

  return (
    <>
      <Scroll />
      <section id="castanha-cajueiros-section">
        <h1>{t("castanha.cajueiros.titulo")}</h1>
        <div className="cajueiros-container">
          <div className="flex">
            <img
              src={cajueiroPirangi}
              alt="Imagem do Cajueiro de Pirangi do Norte"
            />
            <p
              dangerouslySetInnerHTML={{ __html: t("castanha.cajueiros.p1") }}
            />
          </div>
          <p>
            {t("castanha.cajueiros.p2")}
            <br />
            {t("castanha.cajueiros.p3")}
            <br />
            {t("castanha.cajueiros.p4")}
          </p>
          <div className="flex">
            <div>
              <p
                dangerouslySetInnerHTML={{ __html: t("castanha.cajueiros.p5") }}
              />
              <p
                dangerouslySetInnerHTML={{ __html: t("castanha.cajueiros.p6") }}
              />
              <a
                href="https://www.geneticsmr.com"
                target="_blank"
                rel="noreferrer"
              >
                www.geneticsmr.com
              </a>
            </div>
            <img src={cajueiroRei} alt="Imagem do Cajueiro Rei" />
          </div>
        </div>
      </section>
    </>
  );
}
